import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { type ApprovedExpenseItemApiModel } from '../api-models/ApprovedExpenseItemApiModel'
import { ApprovedExpenseItemApiModelStub } from '../api-models/stubs/ApprovedExpenseItemApiModel.stub'

export const mockListApprovedExpenseItemsSuccess = (
  data: ApprovedExpenseItemApiModel[] = ApprovedExpenseItemApiModelStub.buildList(
    1
  ),
  pagination = {}
) => {
  return http.get(
    '/api/v3/expenses/items/approved/',
    () => {
      return HttpResponse.json(getResponseObject(data, pagination), {
        status: 200,
      })
    },
    { once: true }
  )
}
